/** Owned delivery copy (de/fr/pl/nl). EN = SSR. Hosts use `.no-translate-wg`. */
(function () {
  const OWNED = new Set(['de', 'fr', 'pl', 'nl']);
  const MONTHS = {
    de: 'Jan,Feb,Mär,Apr,Mai,Jun,Jul,Aug,Sep,Okt,Nov,Dez'.split(','),
    fr: 'janv.,févr.,mars,avr.,mai,juin,juil.,août,sept.,oct.,nov.,déc.'.split(','),
    pl: 'sty.,lut.,mar.,kwi.,maj,cze.,lip.,sie.,wrz.,paź.,lis.,gru.'.split(','),
    nl: 'jan,feb,mrt,apr,mei,jun,jul,aug,sep,okt,nov,dec'.split(','),
  };
  const COPY = {
    de: {
      in_stock: ['Auf Lager', ' – Lieferung: {range}'],
      low: ['Nur noch {count} verfügbar', ' – Lieferung: {range}'],
      back: 'Voraussichtliche Lieferung: {range}',
      ship: 'Kostenloser Versand ab {amount}',
      cart: 'Voraussichtliche Lieferung: ',
    },
    fr: {
      in_stock: ['En stock', ' — livraison : {range}'],
      low: ['Plus que {count} en stock', ' — livraison : {range}'],
      back: 'Livraison estimée : {range}',
      ship: 'Livraison gratuite dès {amount}',
      cart: 'Livraison estimée : ',
    },
    pl: {
      in_stock: ['W magazynie', ' – dostawa: {range}'],
      low: ['Zostało tylko {count} szt.', ' – dostawa: {range}'],
      back: 'Przewidywana dostawa: {range}',
      ship: 'Darmowa dostawa od {amount}',
      cart: 'Przewidywana dostawa: ',
    },
    nl: {
      in_stock: ['Op voorraad', ' – levering: {range}'],
      low: ['Nog {count} beschikbaar', ' – levering: {range}'],
      back: 'Geschatte levering: {range}',
      ship: 'Gratis verzending vanaf {amount}',
      cart: 'Geschatte levering: ',
    },
  };

  const lang = () =>
    (location.pathname.match(/^\/(de|fr|pl|nl)(?:\/|$)/i) || [])[1]?.toLowerCase() ||
    (OWNED.has(window.NoomaWeglotChrome?.currentLang?.() || '') ? window.NoomaWeglotChrome.currentLang() : '');

  const esc = (s) => String(s).replace(/&/g, '&amp;').replace(/</g, '&lt;');
  const fmt = (iso, l) => {
    if (!iso) return '';
    const end = new Date(`${iso}T12:00:00`);
    if (Number.isNaN(end.getTime())) return '';
    const mo = MONTHS[l] || MONTHS.de;
    return window.NoomaBusinessDays.formatDeliveryRange(end, mo);
  };
  const span = (r) => (r ? `<span class="dev-product-card-delivery__range">${esc(r)}</span>` : '');
  const tpl = (t, r) => {
    const p = t.split('{range}');
    return `${p[0] || ''}${span(r)}${p[1] || ''}`;
  };

  function paintRow(row, d, l) {
    const status = row.dataset.deliveryStatus || row.dataset.devBundleDeliveryRow;
    const label = row.querySelector('.dev-product-card-delivery__label');
    const sec = row.querySelector('.dev-product-card-delivery__secondary');
    if (!label || !status) return;
    const range = fmt(row.dataset.deliveryEnd, l);
    const root = row.closest('[data-dev-bundle-delivery-root]');
    const amt =
      row.dataset.freeShippingAmount?.trim() ||
      (root instanceof HTMLElement ? root.dataset.freeShippingAmount?.trim() : '');
    if (sec && amt) sec.textContent = d.ship.replace('{amount}', amt);
    if (status === 'in_stock') {
      label.innerHTML = `<span class="dev-product-card-delivery__label-status">${esc(d.in_stock[0])}</span>${tpl(d.in_stock[1], range)}`;
    } else if (status === 'low_stock') {
      const n = parseInt(row.dataset.deliveryCount || '', 10);
      let countText = '';
      if (Number.isFinite(n)) {
        countText =
          l === 'pl' && n === 1 ? 'Została tylko 1 szt.' : d.low[0].replace('{count}', String(n));
      }
      const countHtml = countText
        ? `<span class="dev-product-card-delivery__label-warning">${esc(countText)}</span>`
        : '';
      label.innerHTML = countHtml + tpl(d.low[1], range);
    } else if (status === 'back_order') {
      label.innerHTML = tpl(d.back, range);
    }
  }

  function paintCartNode(node, d, l) {
    const label = node.querySelector('.cart-delivery-info__label');
    const date = node.querySelector('.cart-delivery-info__date');
    if (label && date) {
      label.textContent = d.cart;
      date.textContent = fmt(node.dataset.deliveryEnd, l);
    }
  }

  function paint(root = document) {
    const l = lang();
    if (!OWNED.has(l)) return;
    const d = COPY[l];
    if (!d) return;
    const scope = root instanceof HTMLElement ? root : document;
    scope
      .querySelectorAll('[data-delivery-row][data-delivery-status], [data-delivery-row][data-dev-bundle-delivery-row]')
      .forEach((row) => paintRow(row, d, l));
    const cartSel = 'dev-cart-delivery[data-delivery-end]';
    if (root instanceof HTMLElement && root.matches(cartSel)) {
      paintCartNode(root, d, l);
    } else {
      scope.querySelectorAll(cartSel).forEach((node) => paintCartNode(node, d, l));
    }
  }

  window.NoomaDeliveryI18n = { paint, currentLang: lang };
  window.addEventListener('weglot:ready', () => paint());
  window.Weglot?.on?.('languageChanged', () => paint());
})();
